const KEY = 'pinweelo-block-v1'

export const readBlock = () => {
  try {
    const data = JSON.parse(localStorage.getItem(KEY) || 'null')
    if (!data || !data.until) return null
    if (data.until > 0 && data.until < Date.now()) {
      localStorage.removeItem(KEY)
      return null
    }
    return data
  } catch (err) {
    return null
  }
}

export const saveBlock = (payload) => {
  if (!payload || payload.msg !== 'blocked') return
  const data = {
    until: Number(payload.until) || 0,
    reason: String(payload.reason || ''),
    text: String(payload.text || 'You are blocked.')
  }
  localStorage.setItem(KEY, JSON.stringify(data))
  window.dispatchEvent(new Event('pinweelo-block'))
}

export const clearBlock = () => {
  localStorage.removeItem(KEY)
  window.dispatchEvent(new Event('pinweelo-block'))
}
